import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "service flex warp m-t-20"
};
const _hoisted_2 = ["onClick"];
import { ref } from "vue";
import api from "@/api/examine";
export default {
  __name: 'index',
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否为分配客服
    isAssigned: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const serviceId = ref([]); // 选择的客服id
    const handleClick = item => {
      if (props.multiple) {
        // 多选
        const index = serviceId.value.indexOf(item.id);
        if (index !== -1) {
          serviceId.value.splice(index, 1);
        } else {
          serviceId.value.push(item.id);
        }
      } else {
        // 单选
        serviceId.value = [item.id];
      }
    };
    const services = ref([]);
    const loading = ref(false);
    // 获取客服列表
    const getSelectList = async () => {
      try {
        loading.value = true;
        const {
          data
        } = await api.examineSelect();
        services.value = data.data.kfUsers;
        if (!props.isAssigned) {
          serviceId.value = data.data.kfUsers.filter(i => i.autoAssign).map(i => i.id);
        }
      } finally {
        loading.value = false;
      }
    };
    __expose({
      serviceId,
      getSelectList
    });
    return (_ctx, _cache) => {
      const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
      const _component_el_skeleton = _resolveComponent("el-skeleton");
      return _openBlock(), _createBlock(_component_el_skeleton, {
        loading: loading.value,
        animated: "",
        class: "m-t-20"
      }, {
        template: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, item => {
          return _createVNode(_component_el_skeleton_item, {
            key: item,
            class: "skeleton"
          });
        }), 64))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass([{
              active: serviceId.value.includes(item.id)
            }, "status-indicator justify-center"]),
            onClick: $event => handleClick(item)
          }, [_createElementVNode("span", null, _toDisplayString(item.name), 1)], 10, _hoisted_2);
        }), 128))])]),
        _: 1
      }, 8, ["loading"]);
    };
  }
};